"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _colors = _interopRequireDefault(require("./utils/colors"));

require("../css/spinner.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Spinner =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Spinner, _React$Component);

  function Spinner(props) {
    var _this;

    _classCallCheck(this, Spinner);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Spinner).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "UNSAFE_componentWillMount", function () {
      _this.delay = setTimeout(_this.setReady, _this.props.delay);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillUnmount", function () {
      clearTimeout(_this.delay);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setReady", function () {
      _this.setState({
        ready: true
      });
    });

    _this.state = {
      ready: _this.props.delay === 0
    };
    return _this;
  }

  _createClass(Spinner, [{
    key: "render",
    value: function render() {
      var _classnames;

      if (!this.state.ready) {
        return null;
      }

      var _this$props = this.props,
          className = _this$props.className,
          color = _this$props.color,
          delay = _this$props.delay,
          size = _this$props.size,
          props = _objectWithoutProperties(_this$props, ["className", "color", "delay", "size"]);

      var classes = (0, _classnames2.default)((_classnames = {
        'vn-spinner': true
      }, _defineProperty(_classnames, "vn-color--".concat(color), color !== undefined), _defineProperty(_classnames, className, className !== ''), _classnames));
      return _react.default.createElement("svg", _extends({}, props, {
        className: classes,
        height: size,
        viewBox: "0 0 32 32",
        width: size
      }), _react.default.createElement("circle", {
        role: "presentation",
        cx: 16,
        cy: 16,
        r: 13,
        stroke: "currentColor",
        fill: "none",
        strokeWidth: "2",
        strokeDasharray: Math.PI * 14,
        strokeLinecap: "round"
      }));
    }
  }]);

  return Spinner;
}(_react.default.Component);

Spinner.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.oneOf(_colors.default),
  delay: _propTypes.default.number,
  size: _propTypes.default.oneOf([12, 16, 24, 32, 48, 64, 72, 96, 128, 256])
};
Spinner.defaultProps = {
  className: '',
  color: undefined,
  delay: 0,
  size: 24
};
Spinner.displayName = 'Spinner';
var _default = Spinner;
exports.default = _default;